import { connect } from 'react-redux';
import { actions as playerActions } from 'features/player';

const mapDispatchToProps = {
  fetchPlayerInformations: playerActions.fetchPlayerInformations,
};

const withConnect = connect(null, mapDispatchToProps, null, { pure: false });

export default withConnect;